import { store as requestStatusStore } from './common';
import { routes as feedingRoutes } from './feeding';
import {
	routes as programacaoAbateRoutes,
	store as programacaoAbateStore
} from './programacaoAbate';

import {
	routes as planejamentoAlojamentoRoutes,
	store as planejamentoAlojamentoStore
} from './planejamentoAlojamento';
import { routes as mortalityControlRoutes } from './MortalityControl';
import { routes as mortalityCausesRoutes } from './MortalityCauses';
import { routes as pedidosRacaoRoutes } from './pedidosRacao';
import { routes as mortalityDistributionRoutes } from './MortalityDistribution';
import { routes as producersWithoutAccessRoutes } from './ProducersWithoutAccess';
import { routes as boletimSanitario } from './boletimSanitario';

const routes = [
	...feedingRoutes,
	...programacaoAbateRoutes,
	...mortalityControlRoutes,
	...mortalityDistributionRoutes,
	...mortalityCausesRoutes,
	...pedidosRacaoRoutes,
    ...producersWithoutAccessRoutes,
	...planejamentoAlojamentoRoutes,
	...boletimSanitario,
];

const modules = {
	requestStatus: requestStatusStore,
	programacaoAbate: programacaoAbateStore,
	planejamentoAlojamento: planejamentoAlojamentoStore,
};

export { routes, modules };
